import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { black, red } from 'Styles/colors';
import { fontBody, fontTitle } from 'Styles/fonts';

const LinkGroupPaddingValues = {
  sm: '8px',
  md: '28px',
  lg: '32px'
};

export const Link = styled.a`
  display: block;
  position: relative;
  text-decoration: none;
  color: ${({ color, withHighlight }) =>
    color || (withHighlight ? red : black)};
  ${({ variant }) =>
    variant === 'mini' ? `${fontBody(14)};` : `${fontBody(16)};`}

  &:hover {
    text-decoration: underline;
  }

  ${({ $withArrow, variant }) =>
    $withArrow &&
    `
      &::after {
        font-family: var(--icon-font);
        content: '\\F008';
        position: absolute;
        ${
          variant === 'mini'
            ? `
            font-size: 14px;
            margin: 0 4px;
          `
            : `
            font-size: 24px;
            margin: 0 10px;
          `
        }
    `}
`;

export const HeaderLink = styled(Link)`
  padding-top: ${ifProp('withTopMargin', '16px', '0')};
  ${fontTitle(16)};
  padding-bottom: 12px;
  font-family: var(--accent-font);
  ${({ accentFont }) =>
    accentFont && 'font-family: var(--accent-font); font-weight: 400;'}
  &::after {
    font-size: 16px;
  }
`;

export const SubtextLink = styled(Link)`
  ${fontTitle(12)}
  padding-bottom: 12px;
`;

export const Subtitle = styled.h2`
  color: ${black};
  padding-bottom: 12px;
  padding-left: ${ifProp('withLeftMargin', '24px', '0')};
  ${({ variant }) =>
    variant === 'mini' ? `${fontTitle(12)};` : `${fontTitle(16)};`}
  ${({ accentFont }) =>
    accentFont && 'font-family: var(--accent-font); font-weight: 400;'}
`;

export const LinkGroup = styled.div`
  ${({ withHorizontalPadding }) =>
    withHorizontalPadding && 'padding-left: 24px; padding-right:24px'};
  ${({ paddingSize }) => `
    padding-bottom: ${
      LinkGroupPaddingValues[paddingSize] || LinkGroupPaddingValues.sm
    };
  `}
  display: flex;
  flex-direction: column;
  ${({ variant }) => (variant === 'mini' ? 'row-gap: 12px' : 'row-gap: 16px;')};
`;
